import publicUrl from './publicUrl';



export default publicUrl(() => '/administration/users');
